import React from 'react'

import { API, CEGID } from 'services';

import { AbstractContainer } from 'containers';

import { InvoiceListScene } from 'scenes';

class InvoiceListContainer extends AbstractContainer {

  getTasks() {

    return [
      {
        key: 'invoices',
        exec: (done, failure) => {
            API.get('clinics')
            .then((response) => {
  
              Promise.all(response.data.map((clinic) => {
                return new Promise((resolve, reject) => {
                  Promise.resolve(CEGID.get(`/getInvoicesFromEmail`, {email: clinic.email}))
                  .then((response) => {
                    resolve(response.map(array => {
                        const tmp = array
                        tmp.email = clinic.email
                        tmp.name = clinic.name
                        tmp.active = true
                        return tmp
                    })) 
                  }
                )
                })
              })).then((values) => {
                done(values)
              }
                
              )
              
            })
            .catch(failure);
          }
        }
    ]
  }

  getComponent(results) {

    const flatArray = [].concat(...results.invoices)
    return <InvoiceListScene invoices={flatArray} />
  }
}

export default InvoiceListContainer;
